// extracted by mini-css-extract-plugin
export default {"switch":"main-switch_lufG4","checked":"main-checked_yGQCt","thumb":"main-thumb_TqZsS"};